import { render, staticRenderFns } from "./showCustomer.vue?vue&type=template&id=e1bdd3d4&"
import script from "./showCustomer.vue?vue&type=script&lang=js&"
export * from "./showCustomer.vue?vue&type=script&lang=js&"
import style0 from "./showCustomer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports